import { css } from '@emotion/core'

const headerHeight = '50px'
const actionsHeight = '70px'

export default ({
  theme: {
    colors,
    typography,
    zIndex,
    components: { filterPanels }
  }
}) => css`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: ${filterPanels.backgroundColor};
  top: 0;
  left: 0;
  z-index: ${zIndex.filterPanel.activePanel};

  .filter-panel__header {
    margin: 0 1rem;
    height: ${headerHeight};
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.primary};
    color: ${colors.primary};
    font-family: ${typography.headings.fontFamily};
  }

  .filter-panel__menu {
    z-index: ${zIndex.filterPanel.menu};

    .menu__item {
      text-transform: uppercase;
      padding: 0.5rem 3rem;
      vertical-align: middle;
      text-align: center;
      line-height: 1em;
      background-color: ${filterPanels.backgroundColor};
      border: 1px solid ${colors.primary};
      color: ${colors.primary};
      display: table;
      width: 300px;
    }
  }

  .applied-filters {
    width: 300px;
    margin: 0 auto;
  }

  .filter-panel__filter {
    z-index: ${zIndex.filterPanel.panel};
  }

  .panel {
    position: absolute;
    top: 92px;
    left: 0;
    bottom: ${actionsHeight};
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${colors.primary};

    &.filter-panel__filter {
      margin-bottom: 0;
    }

    > * {
      margin-bottom: 0.75rem;

      &:last-child {
        margin-bottom: 0;
      }

      > * {
        margin-bottom: 0.75rem;

        &:last-child {
          margin-bottom: 0;
        }

        svg[name='keyboard_arrow_right'] {
          display: none;
        }
      }
    }
  }

  .loader-container {
    display: none;
  }

  &.active {
    .filter-panel__filter {
      background-color: ${filterPanels.backgroundColor};
      z-index: ${zIndex.filterPanel.activePanel};

      /* spinner */
      .loader-container {
        display: block;
        position: fixed !important;
        width: 95%;
        height: 78%;

        .loader,
        .loader:after {
          border-radius: 50%;
          width: 4rem;
          height: 4rem;
        }

        .loader {
          border-top: 0.5em solid rgba(0, 0, 0, 0.4);
          border-right: 0.5em solid rgba(0, 0, 0, 0.4);
          border-bottom: 0.5em solid rgba(0, 0, 0, 0.4);
          border-left: 0.5em solid #000;
        }
      }
    }

    .store-filter {
      .spinner {
        display: none;
      }
    }
  }

  .filter-panel__actions {
    height: ${actionsHeight};
    border-top: 1px solid ${colors.secondary};
    background-color: ${filterPanels.backgroundColor};
    padding: 1rem;
    width: 100%;
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    > * {
      text-align: center;
      min-width: 45%;
      font-size: 0.9rem;
      line-height: 1em;
      text-transform: uppercase;
      display: block;
      margin: 0 auto;
      position: relative;
      padding: 0.5rem 1rem;
      background-color: ${colors.primary};
      color: ${colors.complementary.primary};
    }
    button {
      border: none;
      appearance: none;
    }
  }

  .filter-panel__title {
    text-align: center;
    text-transform: uppercase;
    font-size: ${typography.sizes.large};
    width: 100%;
    color: ${colors.primary};
  }

  .back-to-menu {
    position: absolute;
    top: 10px;
    left: 0;
    padding: 0.5rem;

    svg {
      display: block;
      transform: rotate(180deg);
      width: 22px;
      height: 12px;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .close-modal {
    position: absolute;
    top: 12px;
    right: 0;
    width: 1.5rem;
    height: 1.5rem;
    z-index: ${zIndex.filterPanel.closeDialog};
  }

  .panel-buttons__apply {
    &.disabled {
      background-color: ${filterPanels.diabledBackground};
      color: ${filterPanels.disabledText};
    }
  }

  .price-filter-container {
    width: 100%;
    max-width: 250px;
    > * {
      margin: 0 auto;
    }
  }

  .sale-filter {
    display: flex;
    justify-content: center;
  }

  .store-filter {
    width: 100%;
    height: 100%;
    padding: 0 1rem;
    .list {
      max-height: calc(100% - ${actionsHeight});
      overflow: scroll;
    }
  }

  .sorting-panel {
    .labeled-checkbox {
      margin-bottom: 0.75rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .price-filter-container {
    > * {
      margin-bottom: 0.75rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`
